import styled from "styled-components";

export const ContainerQuestionYesNoBox = styled.div`
  display: flex;
  justify-content: center;
`;
